import { AsyncTask, SimpleIntervalJob, ToadScheduler } from 'toad-scheduler';

const checkAndUpdateSelectedMirror = {
  created() {
    this.createJobCheckAndUpdateSelectedMirror();
  },

  destroyed() {
    this.deleteJobCheckAndUpdateSelectedMirror();
  },
  watch: {
    statusCheckAndUpdateSelectedMirror(newStatus) {
      if (newStatus) this.startJobCheckAndUpdateSelectedMirror();
      else this.stopJobCheckAndUpdateSelectedMirror();
    },
  },
  data() {
    return {
      scheduler: null,
      _checkUpdateJobId: 'JobCheckAndUpdateSelectedMirror',
    };
  },
  methods: {
    createJobCheckAndUpdateSelectedMirror() {
      if (this.scheduler) this.deleteJobCheckAndUpdateSelectedMirror();

      this.scheduler = new ToadScheduler();
      const task = new AsyncTask('checkAndUpdateSelectedMirror', () =>
        Promise.resolve(this.checkAndUpdateSelectedMirror()),
      );
      const job = new SimpleIntervalJob(
        {
          seconds: parseInt(
            process.env.VUE_APP_INTERVAL_CHECK_FOR_CHANGE_MIRROR || 10,
          ),
        },
        task,
        this._checkUpdateJobId,
      );
      this.scheduler.addSimpleIntervalJob(job);
    },
    checkAndUpdateSelectedMirror() {
      this.$store.dispatch('mirror/checkAndUpdateSelectedMirror', {
        programName: this.$route.params.program_tag,
        place: this.$route.params.place,
      });
    },
    startJobCheckAndUpdateSelectedMirror() {
      this.stopJobCheckAndUpdateSelectedMirror();
      if (this.scheduler) this.scheduler.startById(this._checkUpdateJobId);
    },
    stopJobCheckAndUpdateSelectedMirror() {
      if (this.scheduler) this.scheduler.stopById(this._checkUpdateJobId);
    },
    deleteJobCheckAndUpdateSelectedMirror() {
      this.$store.dispatch('mirror/stopJobCheckAndUpdateSelectedMirror');
      if (this.scheduler) {
        this.scheduler.removeById(this._checkUpdateJobId);
        this.scheduler.stop();
        this.scheduler = null;
      }
    },
  },
};

export default checkAndUpdateSelectedMirror;
